import apiClient from '../apiClient';
import { trackPromise } from 'react-promise-tracker';

// ==========================
// GETS
// ==========================

async function listFactories() {
    const { data } = await trackPromise(apiClient.get('/api/factory/getAll'));
    return data?.data ?? [];
}

async function listEnabledFactories() {
    const { data } = await trackPromise(apiClient.get('/api/factory/getAllEnabled'));
    return data?.data ?? [];
}

async function getFactoryById(id) {
    const { data } = await trackPromise(apiClient.get(`/api/factory/getById/${id}`));
    return data?.data ?? null;
}

// ==========================
// MUTATIONS
// ==========================

async function createFactory(payload) {
    const { data } = await trackPromise(apiClient.post('/api/factory/add/', payload));
    return data; // { success, message, data }
}

async function updateFactory(id, payload) {
    const { data } = await trackPromise(apiClient.put(`/api/factory/updateById/${id}`, payload));
    return data;
}

async function toggleFactory(id) {
    const { data } = await trackPromise(apiClient.put(`/api/factory/enabledDisable/${id}`));
    return data;
}

// ==========================
// EXPORT
// ==========================

const factoryService = {
    listFactories,
    listEnabledFactories,
    getFactoryById,
    createFactory,
    updateFactory,
    toggleFactory
};

export default factoryService;
